import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { useSite } from "@/lib/site";

export default function Footer() {
  const { t } = useI18n();
  const { site } = useSite();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-black text-zinc-500 border-t border-zinc-900 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 gap-6 items-center">
        <div className="flex items-center gap-3">
          {site?.logo_url ? (
            <img src={site.logo_url} alt="" className="h-12 w-12 object-contain" />
          ) : (
            <div className="h-12 w-12 bg-black border border-brand-red flex items-center justify-center text-white font-display font-black text-sm">GBS</div>
          )}
          <div className="flex flex-col leading-tight">
            <span className="font-display font-extrabold chrome-text text-sm">George Body Shop</span>
            <span className="tech-label !text-[10px] !text-zinc-600">{t("footer.builtFor")}</span>
          </div>
        </div>
        <div className="text-xs sm:text-sm sm:text-right flex sm:justify-end gap-4 items-center flex-wrap">
          <span>© {year} {site?.business_name || "GBS Collision"}. {t("footer.rights")}</span>
          <Link to="/admin" className="hover:text-brand-red transition-colors" data-testid="footer-admin-link">{t("nav.admin")}</Link>
        </div>
      </div>
    </footer>
  );
}
